import { Avatar, Box, Stack } from "@mui/material";
import { IconMapPin } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { GroupIcon } from "../../../../components/icons";
import Button from "../../../../components/ui/Button";
import SafeHtml from "../../../../components/ui/SafeHtml";
import Text from "../../../../components/ui/Text";

export const GroupHeader = ({ groupData }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      const fullHeight = contentRef.current.scrollHeight;
      setContentHeight(fullHeight);
      setShowReadMore(fullHeight > 80);
    }
  }, [groupData.description]);
  return (
    <Box sx={{ p: { xs: 0, md: 3 }, pb: { xs: 1, md: 1 } }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <Avatar
          src={groupData?.avatar_image_url}
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
          }}
        >
          <GroupIcon width={50} height={50} />
        </Avatar>
        <Text variant="pageHeader" sx={{ mb: "0px !important" }}>
          {groupData.name}
        </Text>
      </Box>

      <Stack spacing={2} sx={{ px: { xs: 1, md: 0 } }}>
        {/* Location */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <IconMapPin size={16} />
          <Text variant="paragraph">{`${groupData.city}, ${groupData.country}`}</Text>
        </Box>

        {/* Stats */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              flex: 1,
              borderRadius: "8px",
              p: 1,
              border: "1px solid #E5E5E5",
            }}
          >
            <Text variant="paragraph3" sx={{ mb: "4px" }}>
              Total members
            </Text>
            <Text variant="paragraph" sx={{ fontSize: "22px" }}>
              {groupData.active_players.length}
            </Text>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              flex: 1,
              borderRadius: "8px",
              p: 1,
              border: "1px solid #E5E5E5",
            }}
          >
            <Text variant="paragraph3" sx={{ mb: "4px" }}>
              Total games played
            </Text>
            <Text variant="paragraph" sx={{ fontSize: "22px" }}>
              {groupData.total_games_played || 0}
            </Text>
          </Box>
        </Box>

        {/* Description */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box
            ref={contentRef}
            sx={{
              maxHeight: isExpanded ? `${contentHeight}px` : "80px",
              overflow: "hidden",
              position: "relative",
              transition: "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          >
            <SafeHtml
              html={groupData.description}
              sx={{
                lineHeight: 1.5,
                fontSize: "14px",
                fontFamily: "inherit",
              }}
            />
            {!isExpanded && showReadMore && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "60px",
                  background: "linear-gradient(to bottom, transparent, white)",
                  transition: "opacity 0.3s ease",
                  opacity: isExpanded ? 0 : 1,
                }}
              />
            )}
          </Box>
          {showReadMore && (
            <Button
              variant="tertiary"
              onClick={() => setIsExpanded(!isExpanded)}
              sx={{
                mt: 1,
                p: 0,
                px: 1,
                fontSize: "14px",
                height: "auto",
                ml: "auto",
              }}
            >
              {isExpanded ? "Show less" : "Read more"}
            </Button>
          )}
        </Box>
      </Stack>
    </Box>
  );
};
